<template>
    <div class="scan">
        <div class="top-container">
            <span class="placeholder">Click Part to start connect</span>
            <div class="more" @click="mineClick"></div>
        </div>
        <div class="start-pairing-container">
            <button class="start-pairing" @click="startPair">START PAIRING</button>
        </div>
        <van-popup v-model="showBindDialog" class="bind-dialog" round opened="onPopupOpened">
            <BindDeviceDialog :is-bind="isBind" :mac-address="macAddress" v-show="showBindDialog"
                              v-on:onCloseBindDialog="onCloseBindDialog"/>
        </van-popup>
    </div>
</template>

<script>
    import bluetoothRepository from '../repository/bluetooth/BluetoothRepository'
    import {mapState} from 'vuex'
    import StoreType from "../vuex/StoreType"
    import BindDeviceDialog from "./BindDeviceDialog"

    export default {
        name      : "Scan",
        components: {BindDeviceDialog},
        data() {
            return {
                showBindDialog: false,
                isBind        : false,
                macAddress    : ''
            }
        },
        methods   : {
            //开始匹配蓝牙设备
            startPair() {
                bluetoothRepository.startPair((macAddress, isBind) => {
                    if (!isBind) { //没有绑定的设备，弹出对话框，去服务器查询
                        this.macAddress     = macAddress
                        this.isBind         = isBind
                        this.showBindDialog = true
                    }
                })
            },
            onCloseBindDialog() {
                this.showBindDialog = false

                bluetoothRepository.disconnect()
            },

            mineClick() {
                this.$router.push("Mine")
            },
        }
    }
</script>

<style lang="scss" scoped>
    .scan {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .bind-dialog {
            width: 80%;
        }

        .start-pairing-container {
            flex: 1;
        }


        .top-container {
            display: flex;
            margin-top: 24px;
            flex-direction: row;

        }
    }

    .start-pairing {
        background: #ED6C0F;
        color: #f6f6f6;
        border: 0;
        padding: 16px;
        border-radius: 32px;
    }

    .placeholder {
        text-align: center;
        height: 200px;
        color: #FFFFFF;
    }

    .more {
        position: absolute;
        padding: 2px;
        width: 13px;
        height: 13px;
        right: 16px;
        top: 24px;
        background-repeat: no-repeat;
        background-position: right;
        background-size: cover;
        @include bg-image("../assets/more");
    }

</style>